<template>
  <div class="app-wrap" :style="themeStyleVars">
    <NuxtRouteAnnouncer />
    <NuxtLoadingIndicator
      color="linear-gradient(90deg, #7dd3c7 0%, #8ecdf8 52%, #b7e3ff 100%)"
      :height="3"
      :throttle="120"
      :duration="1600"
      :hide-delay="180"
    />
    <template v-if="store.localeCurrencyReady">
      <ClientOnly>
        <LowCodePopupHost />
      </ClientOnly>
      <NuxtLayout name="default" v-if="isUserCenterRoute">
        <NuxtPage />
      </NuxtLayout>
      <NuxtPage v-else />
    </template>
    <div v-else class="startup-loading" role="status" aria-label="正在加载">
      <button v-if="store.localeCurrencyError" class="startup-loading__retry" type="button" @click="retryLocaleCurrency">
        初始化失败，点击重试
      </button>
      <span v-else class="startup-loading__spinner" aria-hidden="true"></span>
    </div>
  </div>
</template>
<script setup>
import { computed, watch, onBeforeMount } from "vue";
import LowCodePopupHost from "@/components/render/popup/LowCodePopupHost.vue";
import { useRoute } from "#app";
import { useMainStore } from "@/composables/store";
import { setToken, setMallAppToken, setIsErpBuyMode, isErpBuyMode } from "@/utils/globalData";
import { get } from "lodash-es";
import config from "@/config/index";
import { resolveShopFaviconUrl } from "@/utils/favicon";
import {
  DEFAULT_THEME_COLOR,
  getSavedThemeColor,
  getThemeCssVars,
  resolveThemeColor,
  changeTheme,
} from "@/utils/themeColor";

 
const store = useMainStore();
const retryLocaleCurrency = () => useNuxtApp().$retryLocaleCurrency?.();
const route = useRoute();
const isUserCenterRoute = computed(() => {
  return (
    route.path === "/user-center"
    || route.path.startsWith("/user-center/")
    || route.path === "/collection/estimation"
     
  );
});
const currentUserSyncPath = computed(() => {
  return route.fullPath;
});
const mallSiteThemeColor = computed(() => {
  return get(store.getMallSiteConfig(), "mallPcTheme");
});
const activeThemeColor = computed(() => {
  return resolveThemeColor(
    mallSiteThemeColor.value,
    process.client ? getSavedThemeColor() : "",
    DEFAULT_THEME_COLOR
  );
});
const themeStyleVars = computed(() => getThemeCssVars(activeThemeColor.value));
const siteTitle = computed(() => store.getSiteInfo()?.pc_SITE_NAME || "商城");
const shopFaviconUrl = computed(() => resolveShopFaviconUrl(
  store.storeInfoDataMap[store.activeStoreServer],
));

useHead(() => ({
  title: siteTitle.value,
  link: [{ key: "app-favicon", rel: "icon", href: shopFaviconUrl.value }],
}));

function getFirstQueryValue(value) {
  return Array.isArray(value) ? value[0] : value;
}

onBeforeMount(() => {
  if (process.client) {
    const nextJyToken = getFirstQueryValue(route.query.setJyToken);
    const nextMallToken = getFirstQueryValue(route.query.setMallToken);
    if (nextJyToken) {
      // 手工直接设置token进到系统
        setToken(nextJyToken);
    }
    if (nextMallToken) {
      setMallAppToken(nextMallToken);
    }

    if(process.client){
      if (route.query.isTbPurchaseOrderMode) {
        window.localStorage.setItem(config.isTbPurchaseOrderModeKey,"1");
      }else{
        window.localStorage.removeItem(config.isTbPurchaseOrderModeKey);
      }
    }
    console.log(window.location.pathname,'window.location.pathname',route.query.batchBindMallOrder==1|| isErpBuyMode())
    if ( (window.location.pathname=='/' || window.location.pathname=='/product/search' ) && (route.query.batchBindMallOrder==1|| isErpBuyMode())) {
      // 采购模式进到系统
      setIsErpBuyMode(true);
    } 
    
  }
})
async function changeThemeColor() {
  if (process.client) {
    changeTheme(activeThemeColor.value);
  }
}
onBeforeMount(async () => {
  if (process.client) {
    changeThemeColor();
    try {
      await store.bootstrapSassmallSession();
    }
    catch {}
  }
});
if (process.client) {
  watch(
    () => [currentUserSyncPath.value, route.query.setJyToken, route.query.setMallToken],
    async () => {
      changeThemeColor();
      try {
        await store.bootstrapSassmallSession();
      }
      catch {}
    },
    { immediate: false }
  );
}
</script>
<style>
.startup-loading {
  display: grid;
  min-height: 100vh;
  place-items: center;
}

.startup-loading__spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #eee;
  border-top-color: #ff7628;
  border-radius: 50%;
  animation: startup-loading-spin 0.8s linear infinite;
}

.startup-loading__retry {
  padding: 12px 20px;
  color: #fff;
  background: #ff7628;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
}

@keyframes startup-loading-spin {
  to { transform: rotate(360deg); }
}

.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}

.layout-enter-active,
.layout-leave-active {
  transition: all 0.4s;
}

.layout-enter-from,
.layout-leave-to {
  filter: grayscale(1);
}

.flex-col {
  display: flex;

}

.flex-row {
  display: flex;

}
</style>
